<template>
  <div class="post-editor">
    <div class="post-editor-header clearfix">
      <div class="header-left">
        <div class="form-label">サムネイル</div>
        <div class="thumbnail-preview">
          <img
            v-if="thumbnail_url"
            :src="thumbnail_url"
            class="img-responsive"
          />
          <i v-else class="fa fa-picture-o"></i>
        </div>
        <div class="form-group">
          <img
            v-if="thumbnailUploading"
            src="@images/loading.gif"
            class="loading-gif"
          />
          <input
            type="file"
            accept="image/*"
            @change="thumbnailSelected($event)"
          />
        </div>

        <div class="form-group">
          <input
            class="form-control"
            type="text"
            v-model="thumbnail_quote_url"
            placeholder="引用の場合はURLを入力してください"
          />
          <a
            class="btn-normal thumb-check-btn"
            @click="checkThumbnailURL($event)"
            >チェック</a
          >
        </div>
        <div class="form-group">
          <a
            class="btn-normal tag-finder-link"
            @click.prevent="onClickTagFinderLink()"
            >タグ編集</a
          >

          <ul class="tag-list">
            <li class="badge" v-for="tag in tags">{{ tag.name }}</li>
          </ul>
        </div>
        <div class="form-group">
          <h3 class="form-subtitle">クリエイター登録</h3>
          <multiselect
            v-model="creator"
            :options="
              (creators || []).map((c) => {
                return { name: `${c.title} ${c.name}`, id: c.id };
              })
            "
            @input="onInputCreator"
            label="name"
            track-by="id"
            :allow-empty="true"
            placeholder="選択してください"
          >
          </multiselect>
        </div>
        <div class="form-group">
          <h3 class="form-subtitle">共同編集者</h3>
          <input type="text" v-model="co_writer_ids" class="form-control" />
          <p>カンマ(,)区切りでid(半角数字)を入力</p>
        </div>
        <div class="form-group">
          <input type="checkbox" id="checkbox" v-model="split" />
          <label for="checkbox" style="font-size: 1.4rem"
            >モバイルでページ分割する</label
          >
        </div>
      </div>

      <div class="header-right">
        <div class="form-group">
          <label class="form-label">タイトル</label>
          <input
            v-model="title"
            type="text"
            class="form-control"
            placeholder="記事のタイトルを入力してください。"
          />
        </div>
        <div class="form-group">
          <label for="" class="form-label">フック文章</label>
          <textarea
            class="form-control"
            v-model="comment"
            name="comment"
            cols="30"
            rows="10"
          ></textarea>
        </div>
        <div class="form-group goal-keywords">
          <label for="" class="form-label">対策キーワード</label>
          <div class="flex">
            <input
              v-for="(value, index) in goalKeywords"
              class="flex1 form-control"
              type="text"
              v-model="goalKeywords[index]"
            />
          </div>
        </div>
        <div class="form-group suggest-keywords">
          <label for="" class="form-label">サジェストワード</label>
          <div class="flex">
            <input
              v-for="(v, i) in [0, 1, 2, 3, 4]"
              class="flex1 form-control"
              type="text"
              v-model="suggestKeywords[v]"
            />
          </div>
          <div class="flex">
            <input
              v-for="(v, i) in [5, 6, 7, 8, 9]"
              class="flex1 form-control"
              type="text"
              v-model="suggestKeywords[v]"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="post-editor-body">
      <ul class="editor-menu-list">
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('header', -1)">
            <i class="fa fa-header"></i>
            見出し
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('text', -1)">
            <i class="fa fa-pencil"></i>
            テキスト
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('table', -1)">
            <i class="fa fa-table"></i>
            表
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('review', -1)">
            <i class="fa fa-comment-o"></i>
            クチコミ
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('quote', -1)">
            <i class="fa fa-quote-right"></i>
            引用
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('link', -1)">
            <i class="fa fa-link"></i>
            リンク
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('post-links', -1)">
            <i class="fa fa-book"></i>
            記事リスト
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('external-post-links', -1)">
            <i class="fa fa-external-link-square"></i>
            他メディアリスト
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('image', -1)">
            <i class="fa fa-file-image-o"></i>
            画像
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('store', -1)">
            <i class="fa fa-building"></i>
            店舗
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('general-product', -1)">
            <i class="fa fa-shopping-bag"></i>
            商品
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('twitter', -1)">
            <i class="fa fa-twitter"></i>
            Twitter
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('insta', -1)">
            <i class="fa fa-instagram"></i>
            Instagram
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('youtube', -1)">
            <i class="fa fa-youtube"></i>
            YouTube
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('product', -1)">
            <i class="fa fa-amazon"></i>
            Amazon
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('talk', -1)">
            <i class="fa fa-vcard"></i>
            会話
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('map', -1)">
            <i class="fa fa-google"></i>
            Map
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('html', -1)">
            <i class="fa fa-file"></i>
            HTML
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('faq', -1)">
            <i class="fa fa-question"></i>
            FAQ
          </a>
        </li>
        <li class="editor-menu-item">
          <a class="editor-menu-link" @click="addItem('coupon', -1)">
            <i class="fa fa-cube"></i>
            クーポン
          </a>
        </li>
      </ul>
      <div class="editor-content">
        <div class="editor-content-list">
          <div
            v-for="(value, idx) in body"
            class="editor-content-item"
            :key="value.id"
          >
            <header-input
              v-if="value.action === 'header'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <text-input
              v-if="value.action === 'text'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <TableEditor
              v-if="value.action === 'table'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <ReviewEditor
              v-if="value.action === 'review'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <StoreEditor
              v-if="value.action === 'store'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <FaqEditor
              v-if="value.action === 'faq'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <ProductEditor
              v-if="value.action === 'general-product'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <PostLinksEditor
              v-if="value.action === 'post-links'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <ExternalPostLinksEditor
              v-if="value.action === 'external-post-links'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <image-input
              v-if="value.action === 'image'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <link-input
              v-if="value.action === 'link'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <instagram-input
              v-if="value.action === 'insta'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <quote-input
              v-if="value.action === 'quote'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <twitter-input
              v-if="value.action === 'tweet'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <youtube-input
              v-if="value.action === 'youtube'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <product-input
              v-if="value.action === 'product'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <talk-input
              v-if="value.action === 'talk'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <google-map-input
              v-if="value.action === 'map'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <html-input
              v-if="value.action === 'html'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
            <CouponEditor
              v-if="value.action === 'coupon'"
              :value="value.value"
              :id="value.id"
              :index="parseInt(idx, 10)"
              ref="inputs"
            />
          </div>
        </div>
        <div class="editor-content-right">
          <PostEditorCheckSheet
            :title="title"
            :comment="comment"
            :body="bodyJSON"
            :goal-keywords="goalKeywords"
            :suggest-keywords="suggestKeywords"
          />
        </div>
      </div>
    </div>
    <TagFinder v-if="tagFinderVisible" :selected="tags" />
  </div>
</template>

<script>
import headerInput from './header-input.vue';
import textInput from './text-input.vue';
import TableEditor from './TableEditor/TableEditor.vue';
import ReviewEditor from './ReviewEditor/ReviewEditor.vue';
import StoreEditor from './StoreEditor/StoreEditor.vue';
import ProductEditor from './ProductEditor/ProductEditor.vue';
import PostLinksEditor from './PostLinksEditor/PostLinksEditor.vue';
import ExternalPostLinksEditor from './ExternalPostLinksEditor/ExternalPostLinksEditor.vue';
import instagramInput from './instagram-input.vue';
import quoteInput from './quote-input.vue';
import imageInput from './image-input.vue';
import linkInput from './link-input.vue';
import twitterInput from './twitter-input.vue';
import youtubeInput from './youtube-input.vue';
import productInput from './product-input.vue';
import talkInput from './talk-input.vue';
import googleMapInput from './google-map-input.vue';
import htmlInput from './html-input.vue';
import PostEditorCheckSheet from './PostEditorCheckSheet/PostEditorCheckSheet.vue';
import TagFinder from './TagFinder/TagFinder.vue';

import {
  deleteAtIndex,
  appendValue,
  replaceIndex,
  getObjectLength,
} from '../utils/sorted-object';
import {
  getGroupEndIndex,
  confirmTargetGroup,
  getPrevGroupStartIndex,
  getNextGroupEndIndex,
  findInputElement,
  setColor,
} from '../utils/group';

import randomize from 'randomatic';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import FaqEditor from './FaqEditor/FaqEditor.vue';
import CouponEditor from './coupon-editor.vue';

export default {
  components: {
    'header-input': headerInput,
    'text-input': textInput,
    'instagram-input': instagramInput,
    'quote-input': quoteInput,
    'twitter-input': twitterInput,
    'youtube-input': youtubeInput,
    'image-input': imageInput,
    'link-input': linkInput,
    'product-input': productInput,
    'talk-input': talkInput,
    'google-map-input': googleMapInput,
    'html-input': htmlInput,
    TagFinder,
    multiselect: Multiselect,
    TableEditor,
    ReviewEditor,
    StoreEditor,
    PostLinksEditor,
    ExternalPostLinksEditor,
    PostEditorCheckSheet,
    ProductEditor,
    FaqEditor,
    CouponEditor,
  },
  props: {
    creators: Array,
  },
  data() {
    return {
      title: '',
      comment: '',
      body: {},
      thumbnail_url: '',
      thumbnail_quote_url: '',
      inputsLength: 0,
      goalKeywords: ['', '', '', '', ''], // 対策キーワード
      suggestKeywords: ['', '', '', '', '', '', '', '', '', ''], // サジェストワード
      thumbnailUploading: false,
      tagFinderVisible: false,
      tags: [],
      creator: null,
      creator_id: null,
      co_writer_ids: '',
      split: false,
      version: '',
    };
  },
  watch: {
    tagFinderVisible(value) {
      if (value) {
        $('body').addClass('no-scroll');
      } else {
        $('body').removeClass('no-scroll');
      }
    },
  },
  mounted() {
    bus.$on('delete-input', (idx) => {
      const body = deleteAtIndex(this.body, idx);
      this.body = body;
    });
    bus.$on('pull-up-item', this.pullUpItem);
    bus.$on('pull-down-item', this.pullDownItem);
    bus.$on('pull-up-group', this.pullUpGroup);
    bus.$on('pull-down-group', this.pullDownGroup);
    bus.$on('add-item', (item, index) => {
      this.addItem(item, index + 1);
    });
    bus.$on('close-tag-finder', () => {
      this.tagFinderVisible = false;
    });
    bus.$on('done-tag-finder', (tags) => {
      this.tagFinderVisible = false;
      this.tags = tags;
    });

    // mountの際にアップデートが走るので要修正
    // 取り急ぎで対応
    setTimeout(() => {
      bus.$emit('editorInitialized');
    }, 1000);
  },
  updated() {
    if (this.$refs.inputs) {
      this.inputsLength = this.$refs.inputs.length;
    }
    bus.$emit('editorUpdated');
  },
  methods: {
    onInputCreator(value) {
      this.creator_id = value === null ? null : value.id;
    },
    onClickTagFinderLink() {
      this.tagFinderVisible = true;
    },
    addItem(type, idx = -1) {
      if (type === 'header') {
        const body = appendValue(
          this.body,
          {
            value: {
              text: '',
              type: 'h2',
            },
            action: 'header',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'text') {
        const body = appendValue(
          this.body,
          {
            value: {
              text: '',
            },
            action: 'text',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'table') {
        const body = appendValue(
          this.body,
          {
            value: {
              text: '',
              isRowHeaderEnabled: true,
              isTableHeaderEnabled: false,
            },
            action: 'table',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'review') {
        const body = appendValue(
          this.body,
          {
            value: {
              review_id: null,
              review: {
                user_name: '',
                score: 1,
                title: '',
                comment: '',
              },
            },
            action: 'review',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'coupon') {
        const body = appendValue(
          this.body,
          {
            value: {
              coupon_id: null,
              title: '',
              body: '',
            },
            action: 'coupon',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'quote') {
        const body = appendValue(
          this.body,
          {
            value: {
              quote_url: '',
              quote_link_text: '',
              quote_text: '',
              comment: '',
            },
            action: 'quote',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'twitter') {
        const body = appendValue(
          this.body,
          {
            value: {
              tweet_url: '',
              html: '',
            },
            action: 'tweet',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'insta') {
        const body = appendValue(
          this.body,
          {
            value: {
              insta_url: '',
              thumbnail_url: '',
              author_name: '',
            },
            action: 'insta',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'youtube') {
        const body = appendValue(
          this.body,
          {
            value: {
              url: '',
            },
            action: 'youtube',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'link') {
        const body = appendValue(
          this.body,
          {
            value: {
              url: '',
              title: '',
              description: '',
              referer: '',
              force_follow: false,
            },
            action: 'link',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'post-links') {
        const body = appendValue(
          this.body,
          {
            value: {
              posts: [],
            },
            action: 'post-links',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'external-post-links') {
        const body = appendValue(
          this.body,
          {
            value: {
              nofollow: true,
              selectedMedia: '',
              externalPosts: [],
            },
            action: 'external-post-links',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
        console.log(this.body);
      }
      if (type === 'image') {
        const body = appendValue(
          this.body,
          {
            value: {
              url: '',
              file: '',
              alt: '',
            },
            action: 'image',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'product') {
        const body = appendValue(
          this.body,
          {
            value: {
              url: '',
              type: 'amazon',
              title: '',
              info: '',
              image_url: '',
            },
            action: 'product',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'talk') {
        const body = appendValue(
          this.body,
          {
            value: {
              text: '',
            },
            action: 'talk',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'map') {
        const body = appendValue(
          this.body,
          {
            value: {
              url: '',
            },
            action: 'map',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'html') {
        const body = appendValue(
          this.body,
          {
            value: {
              html: '',
            },
            action: 'html',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'store') {
        const body = appendValue(
          this.body,
          {
            value: {
              name: '',
              description: '',
              score: 1,
              address: '',
              price: '',
              images: [],
              related_links: [],
            },
            action: 'store',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'faq') {
        const body = appendValue(
          this.body,
          {
            value: {
              title: '',
              items: [],
            },
            action: 'faq',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }
      if (type === 'general-product') {
        const body = appendValue(
          this.body,
          {
            value: {
              name: '',
              description: '',
              score: 1,
              price: '',
              images: [],
              related_links: [],
            },
            action: 'general-product',
            id: randomize('Aa0', 10),
          },
          idx
        );
        this.body = body;
      }

      setTimeout(() => {
        this.setItemIsEditing(idx);
        const lastInput = this.$refs.inputs[this.$refs.inputs.length - 1];
        lastInput.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      });
    },
    async pullUpGroup(startIndex) {
      // it is already at the top
      if (startIndex == 0) {
        return;
      }
      const $el = findInputElement(
        this.body,
        this.$refs.inputs,
        startIndex
      ).$el;
      const endIndex = getGroupEndIndex(
        this.body,
        this.$refs.inputs,
        startIndex
      );
      if (endIndex === undefined) {
        return;
      }
      const ok = await confirmTargetGroup(
        this.$refs,
        this.body,
        startIndex,
        endIndex
      );
      if (!ok) {
        return;
      }

      const prevGroupStartIndex = getPrevGroupStartIndex(
        this.body,
        this.$refs.inputs,
        startIndex
      );
      const diff = startIndex - prevGroupStartIndex;
      for (let cnt = 0; cnt < diff; cnt++) {
        for (let i = startIndex - cnt; i <= endIndex - cnt; i++) {
          this.body = replaceIndex(this.body, i, i - 1);
        }
      }
      await this.$nextTick();
      $el.scrollIntoView({
        behavior: 'smooth',
      });
      await new Promise((resolve) => setTimeout(resolve, 5000));
      setColor(
        this.$refs,
        this.body,
        startIndex - diff,
        endIndex - diff,
        false
      );
    },
    async pullDownGroup(startIndex) {
      // it is already at the bottom
      if (getObjectLength(this.body) - 1 <= startIndex) {
        return;
      }

      const $el = findInputElement(
        this.body,
        this.$refs.inputs,
        startIndex
      ).$el;
      const endIndex = getGroupEndIndex(
        this.body,
        this.$refs.inputs,
        startIndex
      );

      if (endIndex === undefined) {
        return;
      }
      const ok = await confirmTargetGroup(
        this.$refs,
        this.body,
        startIndex,
        endIndex
      );
      if (!ok) {
        return;
      }

      const nextGroupEndIndex = getNextGroupEndIndex(
        this.body,
        this.$refs.inputs,
        startIndex
      );
      const diff = nextGroupEndIndex - endIndex;
      for (let cnt = 0; cnt < diff; cnt++) {
        for (let i = endIndex + cnt; i >= startIndex + cnt; i--) {
          this.body = replaceIndex(this.body, i, i + 1);
        }
      }
      await this.$nextTick();
      $el.scrollIntoView({
        behavior: 'smooth',
      });
      await new Promise((resolve) => setTimeout(resolve, 5000));
      setColor(
        this.$refs,
        this.body,
        startIndex + diff,
        endIndex + diff,
        false
      );
    },
    pullUpItem(idx) {
      if (idx == 0) {
        return;
      }
      const $el = this.$refs.inputs.find(
        (input) => input.id === this.body[idx].id
      ).$el;
      const body = replaceIndex(this.body, idx, idx - 1);
      this.body = body;
      this.$nextTick(() => {
        $el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      });
    },
    pullDownItem(idx) {
      if (getObjectLength(this.body) - 1 <= idx) {
        return;
      }

      const $el = this.$refs.inputs.find(
        (input) => input.id === this.body[idx].id
      ).$el;
      const body = replaceIndex(this.body, idx, idx + 1);
      this.body = body;
      this.$nextTick(() => {
        $el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      });
    },
    setItemIsEditing(idx) {
      const inputs = this.$refs.inputs;

      if (idx < 0) {
        inputs[inputs.length - 1].isEditing = true;
      } else {
        const data = this.body[idx];
        if (data === undefined) {
          let _idx = idx;
          debugger;
        }
        const input = inputs.find((i) => i.id === data.id);
        if (input) {
          input.isEditing = true;
        } else {
          console.error(`inputが存在しない`);
        }
      }
    },
    checkThumbnailURL(e) {
      e.preventDefault();

      $.post({
        url: '/api/image/thumbnail_quote',
        type: 'POST',
        data: {
          url: this.thumbnail_quote_url,
        },
        success: (data) => {
          this.thumbnail_url = data.url;
        },
        error: () => {
          alert('URLが間違っているか、ネットワークエラーが発生しています。');
          return false;
        },
      });
    },
    thumbnailSelected(e) {
      const files = e.target.files;
      if (!files.length) return;
      const fd = new FormData();

      fd.append('image', files[0]);
      this.thumbnailUploading = true;

      $.post({
        url: '/api/image/upload',
        type: 'POST',
        data: fd,
        processData: false,
        contentType: false,
      })
        .then((response) => {
          this.thumbnailUploading = false;
          this.thumbnail_url = response.url;
        })
        .catch((err) => {
          console.error(err);
          this.thumbnailUploading = false;
          alert('URLが間違っているか、ネットワークエラーが発生しています。');
          return false;
        });
    },
  },
  computed: {
    bodyJSON() {
      const json = {};

      if (this.inputsLength) {
        for (const input of this.$refs.inputs) {
          json[input.index] = input.bodyJSON;
        }
      }

      return json;
    },
    tagIds() {
      let res = [];
      for (const tag of this.tags) {
        res.push(tag.id);
      }

      return res;
    },
  },
};
</script>

<style lang="scss">
.post-editor-header {
  display: flex;
  margin-top: 30px;
  margin-left: -10px;
  margin-right: -10px;
}
.thumbnail-preview {
  text-align: center;
  .fa-picture-o {
    font-size: 60px;
    color: #999;
  }
}
.header-left {
  width: 250px;
  padding: 0 10px;

  .tag-list {
    margin-top: 5px;
    .badge {
      display: inline-block;
      margin: 0 5px 5px 0;
    }
  }
}
.thumb-check-btn {
  margin-top: 5px;
}
.loading-gif {
  width: 30px;
  height: 30px;
}
.header-right {
  flex: 1;
  padding: 0 10px;
}
.editor-content {
  margin: 20px -10px;
  display: flex;
}
.editor-content-list {
  margin: 50px 0;
  flex: 1;
  padding: 0 10px;
}
.post-editor-body {
  padding-bottom: 100px;
}
.form-label {
  display: block;
}
.form-subtitle {
  font-size: 1.4rem;
  margin: 1rem 0 0.5rem;
}

.goal-keywords {
  .flex {
    margin: 0 -5px;
  }
  .flex1 {
    margin: 5px;
  }
}

.suggest-keywords {
  .flex {
    margin: 0 -5px;
  }
  .flex1 {
    margin: 5px;
  }
}
.editor-menu-list {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 4px;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fafafa;
}
.editor-menu-item {
  text-align: center;
  font-size: 12px;
  color: #666;

  i {
    display: block;
    font-size: 26px;
    margin: 0 0 10px;
  }
}
.editor-menu-link {
  display: block;
  background: #efefef;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #ddd;
  }
}
.input-footer-menu-item {
  float: left;
  margin-left: 10px;
}
.editor-content-right {
  width: 280px;
  padding: 10px;
}
</style>
